const TYPING_INDICATOR_MAX_TIME = 5000

let typingTimeout: ReturnType<typeof setTimeout> | null

export const setIsTypingWithTimeout = (isTyping: boolean, set: (isTyping: boolean) => void) => {
  if (typingTimeout) {
    clearTimeout(typingTimeout)
  }

  set(isTyping)

  if (isTyping) {
    typingTimeout = setTimeout(() => {
      set(false)
    }, TYPING_INDICATOR_MAX_TIME)
  }
}
